import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

/**
 * Types
 */

type Props = {
  attachId?: string;
  menuMaxHeight?: string;
  menuMaxWidth?: string;
  menuMinWidth?: string;
  text: string;
  value: boolean;
};

/**
 * Component
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenuChip',
  props: {
    attachId: { default: undefined },
    menuMaxHeight: { default: "456" },
    menuMaxWidth: { default: "476" },
    menuMinWidth: { default: "476" },
    text: null,
    value: { type: Boolean }
  },
  emits: ["input", "remove"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: boolean): void;
  (e: "remove"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { attachId: string, menuMaxHeight: string, menuMaxWidth: string, menuMinWidth: string, text: string, value: boolean };





const isOpen = computed({
  get: () => props.value,
  set: (newValue) => {
    emit("input", newValue);
  },
});

const iconColor = computed(() => (isOpen.value ? "primaryWhite" : undefined));

const handleChipClick = () => {
  isOpen.value = !isOpen.value;
};

const handleRemove = () => {
  emit("remove");
};

return { __sfc: true,props, emit, isOpen, iconColor, handleChipClick, handleRemove }
}

})